<template>
	<div class="-mt-10 -mb-4">
		<tw-table
			:placeholder="t('placeholders.noMeetingPlaces')"
			:data="props?.job?.portalData?.portal_meeting_places"
			:loading="loading">
			<!-- description -->
			<tw-table-column 
				header="" 
				prop="job__PLACES__jobID::description_display" />

			<!-- primary -->
			<tw-table-column 
				:header="_localesStore.getLabel('411')">
				<template #default="{row}">
					<CheckIconMini
						v-if="row['job__PLACES__jobID::primary']"
						class="h-5 w-5 text-black" />
					<MinusIconMini
						v-else
						class="h-5 w-5 text-gray-300" />
				</template>
			</tw-table-column>

			<!-- picture -->
			<tw-table-column
				class-name="w-6"
				header-class-name="w-6"
				align-text="right">
				<template #default="{row}">
					<div
						class="h-6 w-6 cursor-pointer"
						@click="openModalDetails(row)">
						<img
							:class="[hasPicture(row) ? 'linked-icon' : 'grayed-icon']"
							src="@/assets/icons/solid/image-fill.svg"
							alt="picture icon">
					</div>
				</template>
			</tw-table-column>

			<!-- video -->
			<tw-table-column
				class-name="w-6"
				header-class-name="w-6"
				align-text="right">
				<template #default="{row}">
					<div
						class="h-6 w-6 cursor-pointer"
						@click="openModalDetails(row)">
						<img
							:class="[hasVideo(row) ? 'linked-icon' : 'grayed-icon']"
							src="@/assets/icons/solid/video-fill.svg"
							alt="picture icon">
					</div>
				</template>
			</tw-table-column>
		</tw-table>

		<tw-modal
			:title="selectedPlace?.['job__PLACES__jobID::description_display']"
			:breadcrumb="meetingPlaceDetailsBreadcrumb"
			ref="optionDetailsModal">
			<div class="grid grid-cols-3 gap-6">
				<div class="col-span-3 lg:col-span-1">
					<!-- photo -->
					<data-display
						:label="_localesStore.getLabel('293')">
						<template #custom>
							<div
								v-if="mediaLoading"
								class="w-96 h-75 rounded-md bg-gray-300 animate-pulse" />
							<img
								v-else-if="signedUrlPhoto"
								class="object-cover w-96 h-75 rounded-md"
								:src="signedUrlPhoto">
							<div
								v-else
								class="flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300">
								<img
									class="grayed-icon h-10 w-10"
									src="@/assets/icons/solid/image-fill.svg"
									alt="picture icon">
							</div>
						</template>
					</data-display>
				</div>
				<div class="col-span-3 lg:col-span-1">
					<!-- video -->
					<data-display
						:label="_localesStore.getLabel('294')">
						<template #custom>
							<div
								v-if="mediaLoading"
								class="w-96 h-75 rounded-md bg-gray-300 animate-pulse" />
							<video
								v-else-if="signedUrlVideo"
								controls
								class="object-cover w-96 h-75 rounded-md">
								<source
									type="video/mp4"
									:src="signedUrlVideo">
							</video>
							<div
								v-else
								class="flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300">
								<img
									class="grayed-icon h-10 w-10"
									src="@/assets/icons/solid/video-fill.svg"
									alt="video icon">
							</div>
						</template>
					</data-display>
				</div>			
			</div>
		</tw-modal>
	</div>
</template>

<script lang="ts">
	export default { name: 'MeetingPlaces' } // name the component
</script>

<script setup lang="ts">
	import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { // vue
		inject,
		computed,
		ref
	} from 'vue'	

	const props = defineProps({
		job: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	})

	const _localesStore = localesStore()

	const {t} = useI18n()

	const meetingPlaceDetailsBreadcrumb = computed(() => {
		return [
			{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
			{label: props?.job?.fieldData?.name_bride_groom_display, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
			{label: _localesStore.getLabel('427'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }} // Meeting Places
		]
	})

	const selectedPlace = ref({})
	const optionDetailsModal = ref<{open: boolean}>({open: false})
	const mediaLoading = ref(false)
	const fetchS3File: any = inject('fetchS3File')
	const signedUrlPhoto = ref('')
	const signedUrlVideo = ref('')

	async function openModalDetails(row: any) {
		selectedPlace.value = row
		optionDetailsModal.value.open = true
		try {
			mediaLoading.value = true
			signedUrlPhoto.value = await fetchS3File(row['job__PLACES__jobID::s3JSONPicture'])
			signedUrlVideo.value = await fetchS3File(row['job__PLACES__jobID::s3JSONVideo'])
		}
		catch(e) {
			console.error(e)
		}
		finally {
			mediaLoading.value = false
		}
	}
	
	function hasPicture(row: any) {
		return row?.['job__PLACES__jobID::s3JSONPicture']
	}

	function hasVideo(row: any) {
		return row?.['job__PLACES__jobID::s3JSONVideo']
	}
</script>